import { StarIcon } from '@/components/assets/icons/svgs';
import { ChatBlackIcon } from '@/components/assets/icons/svgs';
import ContentContainer from '@/components/containers/contentContainer';
import CustomButton from '@/shared/button/customButton';
import { api } from '@/utils/api';
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import Popup from '@/shared/popups/popupDetails';
import VerifySubmission from '@/shared/popups/verify';
import { Button, CircularProgress, Divider, IconButton, Pagination, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import LiveLocation from '@/components/dashboard-pages/common-dashboard/location/LiveLocation';
import { toast } from "@/utils/appToast";
import { JobStatusButtonText_Worker } from '@/shared/utils/enum';
import { Spinner } from '@/shared/spinner/spinner';
import { useNavigate } from 'react-router-dom';
import { FilterI } from '@/types/interfaces';
import { useTranslation } from 'react-i18next';
import JobSkeleton from '@/utils/jobskeleton'
import Resizer from "react-image-file-resizer";
import TextArea from '@/shared/textArea/textArea';
import JobPaymentSummarySection from '@/components/job/JobPaymentSummarySection';
import JobCommissionBreakdown from '@/components/job/JobCommissionBreakdown';
import { getPaymentSummary, formatPaymentMethod } from '@/utils/jobPaymentSummary';
import { useAutoMarkReached } from '@/hooks/useAutoMarkReached';
import { useWorkerLocationSocket } from '@/hooks/useWorkerLocationSocket';
import { formatDistanceMeters } from '@/utils/geo';
import { markWorkerJobReached } from '@/utils/markJobReached';

// Status configuration for dynamic rendering

const MyJobs = () => {
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [jobs, setJobs] = useState<any>({});
  const [fetchingJobs, setFetchingJobs] = useState(false);
 const [loadingStripeLink, setLoadingStripeLink] = useState(false);

 const handleStripeOnboarding = async () => {
    try {
      setLoadingStripeLink(true);
      const { status, data } = await api.getAccountLink();

      if (status === "error") {
        setLoadingStripeLink(false);
        return false;
      }

      const onboardingLink = data?.data;
      if (onboardingLink) {
       // setLoadingItem(null);
        window.open(onboardingLink, "_blank", "noopener,noreferrer");
      }
    } catch (err) {
      console.error("Stripe onboarding error:", err);
    } finally {
      setLoadingStripeLink(false);
    }
  };

  const { user } = useSelector((state: { user }) => state.user);
  // Pagination state (dummy for now)
  const [page, setPage] = useState(1);
  const totalPages = 10;
  const navigate = useNavigate();
  // Popup state
  const [selectedJob, setSelectedJob] = useState<any>(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showStripePopup, setShowStripePopup] = useState(false);

  // Verification popup state
  const [showVerificationPopup, setShowVerificationPopup] = useState(false);
  const [pendingAction, setPendingAction] = useState<{ jobId: string; action: string; label: string } | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  // Dispute form state
  const [showDisputeForm, setShowDisputeForm] = useState(false);
  const [disputeIssueType, setDisputeIssueType] = useState<string>('');
  const [disputeDescription, setDisputeDescription] = useState<string>('');
  const [disputeImages, setDisputeImages] = useState<File[]>([]);
  const [disputeImagePreviews, setDisputeImagePreviews] = useState<string[]>([]);
  const [isSubmittingDispute, setIsSubmittingDispute] = useState(false);
  const [activeDisputes, setActiveDisputes] = useState<Record<string, any>>({});
  const [offset, setOffset] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const hasPageBeenRendered = useRef(false);
  const [filterValue, setFilterValue] = useState<FilterI>({
    text: '',
    page: offset,
    limit: pageSize,
    order: 'desc',
    clientName: '',
    workerName: '',
    status: ''
});
  const { t } = useTranslation();
  const getStatusConfig = (status: string) => {
  const statusConfigs = {
    'pending': {
      text: t('clientwait'),
      color: '#A0A0A0',
      dot: 'bg-gray-400',
      showButtons: false,
      buttons: []
    },
    'accepted': {
      text: t('clientwait'),
      color: 'text-blue-500',
      dot: 'bg-blue-500',
      showButtons: true,
      buttons: [
        { label: t(JobStatusButtonText_Worker.confirmed), className: 'bg-blue-500 text-white', labelStyle: 'text-white', action: 'on_my_way', disabled: true }
      ]
    },
    'confirmed': {
      text: t('confirmed'),
      color: 'text-blue-500',
      dot: 'bg-blue-500',
      showButtons: true,
      buttons: [
        { label: t(JobStatusButtonText_Worker.confirmed), className: 'bg-blue-500 text-white', labelStyle: 'text-white', action: 'on_my_way' }
      ]
    },
    'on_my_way': {
      text: t('onTheWay'),
      color: 'text-teal-500',
      dot: 'bg-teal-500',
      showButtons: true,
      buttons: [
        { label: t('confirmArrivalManually'), className: 'bg-blue-500 text-white', labelStyle: 'text-white', action: 'reached' }
      ]
    },
    'reached': {
      text: t('arrivedWaitingConfirmation'),
      color: 'text-orange-500',
      dot: 'bg-orange-500',
      showButtons: false,
      buttons: []
    },
    'in_progress': {
      text: t('serviceInProgress'),
      color: 'text-blue-500',
      dot: 'bg-blue-500',
      showButtons: false,
      buttons: [
        { label: t(JobStatusButtonText_Worker.in_progress), className: 'bg-blue-500 text-white', labelStyle: 'text-white', action: 'finish_job' }
      ]
    },
    'job_finished': {
      text: t('workCompleted'),
      color: 'text-yellow-500',
      dot: 'bg-yellow-500',
      showButtons: false,
      buttons: [
        { label: t(JobStatusButtonText_Worker.job_finished), className: 'bg-blue-500 text-white', labelStyle: 'text-white', action: 'submit_completion' }
      ]
    },
    'successfully_completed': {
      text: t('completed'),
      color: 'text-green-500',
      dot: 'bg-green-500',
      showButtons: false,
      buttons: []
    },
    'cancelled': {
      text: t('cancelled'),
      color: 'text-red-500',
      dot: 'bg-red-500',
      showButtons: false,
      buttons: []
    },
    'rejected': {
      text: t('rejected'),
      color: 'text-red-500',
      dot: 'bg-red-500',
      showButtons: false,
      buttons: []
    },
    'dispute': {
      text: t('dispute'),
      color: 'text-red-500',
      dot: 'bg-red-500',
      showButtons: false,
      buttons: []
    }
  };

  return statusConfigs[status] || statusConfigs['pending'];
};
  // Function to get current location
  const getCurrentLocation = (): Promise<{lat: number, lng: number}> => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        },
        (error) => {
          reject(error);
        }
      );
    });
  };

  // Dynamic status change functions
  const handleStatusChange = async (jobId: string, action: string) => {
    setIsLoading(true);
    try {

      const coords = await getCurrentLocation(); // get location

    const location = {
      latitude: coords.lat,
      longitude: coords.lng,
    };
      let res;
      switch (action) {
        case 'accept':
          res = await api.workerAcceptJob(jobId, { status: "accepted",location });
          setIsLoading(false);
          break;
        case 'reject':
          res = await api.workerAcceptJob(jobId, { status: "rejected",location });
          setIsLoading(false);
          break;
        case 'confirm':
          // res = await api.workerMarkedOnMyWay(jobId);
          console.log('Confirm job functionality not implemented yet');
          setIsLoading(false);
          break;
        case 'on_my_way':
          res = await api.workerMarkedOnMyWay(jobId);
          break;
        case 'reached': {
          const result = await markWorkerJobReached(jobId, {
            lat: location.latitude,
            lng: location.longitude,
          });
          if (result.success) {
            toast.success(t('markAsReached'));
            await fetchJobs();
          } else {
            toast.error(t('arrivalGpsUnavailable'));
          }
          return;
        }
        case 'start_job':
          // res = await api.workerStartJob(jobId);
          console.log('Start job functionality not implemented yet');
          setIsLoading(false);
          break;
        case 'finish_job':
          // res = await api.workerFinishJob(jobId);
          console.log('Finish job functionality not implemented yet');
          setIsLoading(false);
          break;
        case 'submit_completion':
          // res = await api.workerSubmitCompletion(jobId);
          console.log('Submit completion functionality not implemented yet');
          setIsLoading(false);
          break;
        default:
          console.log('Unknown action:', action);
          setIsLoading(false);
          return;
      }
      console.log("res",res)

      if (res && res.success) {
       toast.success(`Job ${action.replace(/_/g, ' ')} successfully`);

        fetchJobs(); // Refresh the jobs list
      } else {
        
        toast.error(` to ${action} job`);
      }
    } catch (err) {
      console.log("catch is calling now")
      console.error(`Failed to ${action} job:`, err);
      const errorMessage =
     // for Axios-style errors
    err?.message ||                 // generic JS error
    `Failed to ${action} job`;      // fallback message
    console.log("errmsg",errorMessage)
  toast.error(errorMessage);
     // toast.error(`Failed to ${action} job`);
    } finally {
      setIsLoading(false);
    }
  };

  // Show verification popup before status change
  const showVerification = (jobId: string, action: string, label: string, stripe: boolean) => {
   
    if(!stripe && label =='Accept'){
          setShowStripePopup(true)
    }else{
    setPendingAction({ jobId, action, label });
    setShowVerificationPopup(true);
    }
  };

  // Confirm status change
  const confirmStatusChange = async () => {
    if (pendingAction) {
      await handleStatusChange(pendingAction.jobId, pendingAction.action);
      setShowVerificationPopup(false);
      setPendingAction(null);
    }
  };

  // Cancel status change
  const cancelStatusChange = async () => {
    // await handleStatusChange(pendingAction.jobId, pendingAction.action);
    setShowVerificationPopup(false);
    setPendingAction(null);
  };

  const fetchJobs = async () => {
    try {
      const res = await api.getMyJobs({ userId: user._id, type: "worker", page: offset, limit: pageSize });
      if (res && res.success) {
        setJobs(res.data || {});
        setFetchingJobs(false);
        hasPageBeenRendered.current = true;
      }
    } catch (err) {
      console.error("Failed to fetch jobs", err);
      setFetchingJobs(false);
    }
  };

  const { gpsAvailable, workerPosition, distancesByJobId, hasActiveTracking } = useAutoMarkReached({
    jobs: jobs?.data ?? [],
    enabled: Boolean(user?._id),
    onReached: fetchJobs,
  });

  useWorkerLocationSocket({
    jobs: jobs?.data ?? [],
    workerId: user?._id ?? '',
    workerPosition,
    enabled: Boolean(user?._id) && hasActiveTracking,
  });

  useEffect(() => {
    if( hasPageBeenRendered.current==true) {
    const delayDebounceFn = setTimeout(() => {
        fetchJobs();
    }, 300);


    return () => clearTimeout(delayDebounceFn);
}
}, [filterValue]);

const handleChangePage = (event: unknown, newPage: number) => {
    setOffset(newPage);
    setFilterValue({ ...filterValue, page: newPage })
}

  // Helper to get location name
  const getLocation = (job: any) => {
    if (job.location?.value) return job.location.value;
    if (typeof job.location === 'string') return job.location;
    return '-';
  };

  // Helper to get service name
  const getServiceName = (job: any) => {
    if (typeof job?.service === 'object' && job?.service?.name) return job?.service?.name;
    if (typeof job?.service === 'string') return job?.service;
    return '-';
  };

  useEffect(() => {
    setFetchingJobs(true);
    fetchJobs();
    fetchActiveDisputes();
  }, []);

  const handleChatNavigation = (selectedJob: any) => {
    console.log("selectedJob",selectedJob)
    console.log("selectedJob",selectedJob?.job?.user?._id, selectedJob?.job?.user?._id, selectedJob?.job?.user?.userProfile )
    navigate('/chat', {
      state: {
        clientId: selectedJob?.job?.user?._id,
        providerId: selectedJob?.job?.user?._id,
        providerProfileId: selectedJob?.job?.user?.userProfile,
        returnTo: '/my-jobs',
      },
    });
  }

  // Check if dispute can be created for a job
  const canCreateDispute = (job: any) => {
    if (!job?.job) return false;
    // Check if user is the job owner (client) or assigned worker
    const isJobOwner = job.job.user?._id === user?._id;
    const isAssignedWorker = job.worker?._id === user?._id;
    if (!isJobOwner && !isAssignedWorker) return false;
    
    // Check if job status allows dispute creation
    // Allow disputes for jobs that have started (reached, in_progress, job_finished) or successfully_completed
    const allowedStatuses = ['reached', 'in_progress', 'job_finished', 'successfully_completed'];
    if (!allowedStatuses.includes(job.status)) return false;
    
    // Check if active dispute already exists
    const activeDispute = activeDisputes[job.job._id];
    if (activeDispute && (activeDispute.status === 'OPEN' || activeDispute.status === 'UNDER_REVIEW')) {
      return false;
    }
    if(job.status == 'successfully_completed' && (!job?.pendingPayout)){
      return false
    }
    return true;
  };

  // Fetch active disputes for jobs
  const fetchActiveDisputes = async () => {
    try {
      const res = await api.getDisputes({ status: 'OPEN,UNDER_REVIEW' });
      if (res && res.success && res.data?.data) {
        const disputesMap: Record<string, any> = {};
        res.data.data.forEach((dispute: any) => {
          if (dispute.job?._id) {
            disputesMap[dispute.job._id] = dispute;
          }
        });
        setActiveDisputes(disputesMap);
      }
    } catch (error) {
      console.error('Error fetching disputes:', error);
    }
  };

  // Dispute image handling
  const resizeDisputeImage = async (file: File) => {
    if (file.size > 10 * 1024 * 1024) {
      toast.error("La imagen no puede superar los 10MB");
      return null;
    }

    return new Promise<Blob>((resolve, reject) => {
      Resizer.imageFileResizer(
        file,
        1500,
        1500,
        'JPEG',
        90,
        0,
        (uri: any) => {
          resolve(uri);
        },
        'blob'
      );
    });
  };

  const handleDisputeImageChange = (files: File[]) => {
    const totalImages = disputeImages.length + files.length;
    if (totalImages > 5) {
      toast.error(t('maxImages') || 'Solo puedes seleccionar hasta 5 imágenes.');
      return;
    }

    const newValidFiles: File[] = [];
    const newPreviewUrls: string[] = [];

    for (const file of files) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error(`La imagen "${file.name}" es mayor a 10MB y fue omitida.`);
        continue;
      }

      newValidFiles.push(file);
      newPreviewUrls.push(URL.createObjectURL(file));
    }

    setDisputeImages(prev => [...prev, ...newValidFiles]);
    setDisputeImagePreviews(prev => [...prev, ...newPreviewUrls]);
  };

  const handleRemoveDisputeImage = (index: number) => {
    setDisputeImages(prev => prev.filter((_, i) => i !== index));
    setDisputeImagePreviews(prev => {
      const newPreviews = prev.filter((_, i) => i !== index);
      // Revoke object URL to free memory
      URL.revokeObjectURL(prev[index]);
      return newPreviews;
    });
  };

  const uploadDisputeImages = async (): Promise<string[]> => {
    if (disputeImages.length === 0) return [];

    const uploadedUrls: string[] = [];

    for (const image of disputeImages) {
      try {
        const resizedImage = await resizeDisputeImage(image);
        if (!resizedImage) continue;

        const formData = new FormData();
        formData.append('file', resizedImage);

        const response = await api.updateJobPhoto(formData);

        if (response && response.success) {
          uploadedUrls.push(response.data || response);
        } else {
          throw new Error(`Failed to upload image: ${response?.message || 'Unknown error'}`);
        }
      } catch (error) {
        console.error('Error uploading image:', error);
        toast.error('Error al subir una imagen. Inténtalo de nuevo.');
      }
    }

    return uploadedUrls;
  };

  const handleSubmitDispute = async () => {
    if (!selectedJob?.job) return;

    // Validation
    if (!disputeIssueType) {
      toast.error(t('issueType') + ' es requerido');
      return;
    }

    if (!disputeDescription || disputeDescription.trim().length < 20) {
      toast.error(t('disputeDescription') + ' debe tener al menos 20 caracteres');
      return;
    }

    if (disputeDescription.length > 2000) {
      toast.error(t('disputeDescription') + ' no puede exceder 2000 caracteres');
      return;
    }

    setIsSubmittingDispute(true);
    try {
      // Upload images first
      const imageUrls = await uploadDisputeImages();

      // Create dispute
      const disputeData = {
        jobId: selectedJob.job._id,
        issueType: disputeIssueType,
        description: disputeDescription.trim(),
        imageUrls: imageUrls,
        createdBy: String(user?._id)
      };

      const res = await api.createDispute(disputeData);

      if (res && res.success) {
        toast.success(t('disputeCreated') || 'Disputa creada exitosamente');
        setShowDisputeForm(false);
        resetDisputeForm();
        fetchJobs();
        fetchActiveDisputes();
      } else {
        const errorMessage = res?.message || res?.data?.message || t('disputeError') || 'Error al crear la disputa';
        
        // Handle specific error messages
        if (errorMessage.includes('job status')) {
          toast.error(t('disputeNotAllowed') || 'Solo puedes crear una disputa para trabajos que han comenzado.');
        } else if (errorMessage.includes('active dispute')) {
          toast.error(t('activeDisputeExists') || 'Ya existe una disputa activa para este trabajo.');
        } else if (errorMessage.includes('authorized')) {
          toast.error(t('unauthorizedDispute') || 'Solo el dueño del trabajo o el trabajador asignado pueden crear una disputa.');
        } else {
          toast.error(errorMessage);
        }
      }
    } catch (error: any) {
      console.error('Error creating dispute:', error);
      const errorMessage = error?.response?.data?.message || error?.message || t('disputeError') || 'Error al crear la disputa';
      
      if (errorMessage.includes('job status')) {
        toast.error(t('disputeNotAllowed') || 'Solo puedes crear una disputa para trabajos que han comenzado.');
      } else if (errorMessage.includes('active dispute')) {
        toast.error(t('activeDisputeExists') || 'Ya existe una disputa activa para este trabajo.');
      } else if (errorMessage.includes('authorized')) {
        toast.error(t('unauthorizedDispute') || 'Solo el dueño del trabajo o el trabajador asignado pueden crear una disputa.');
      } else {
        toast.error(errorMessage);
      }
    } finally {
      setIsSubmittingDispute(false);
    }
  };

  const resetDisputeForm = () => {
    setDisputeIssueType('');
    setDisputeDescription('');
    setDisputeImages([]);
    // Revoke all object URLs
    disputeImagePreviews.forEach(url => URL.revokeObjectURL(url));
    setDisputeImagePreviews([]);
  };

  const openDisputeForm = (job?: any) => {
    const jobToUse = job || selectedJob;
    if (!jobToUse?.job) return;
    if (!canCreateDispute(jobToUse)) {
      const activeDispute = activeDisputes[jobToUse.job._id];
      if (activeDispute) {
        toast.error(t('activeDisputeExists') || 'Ya existe una disputa activa para este trabajo.');
      } else {
        toast.error(t('disputeNotAllowed') || 'Solo puedes crear una disputa para trabajos que han comenzado.');
      }
      return;
    }
    setSelectedJob(jobToUse);
    resetDisputeForm();
    setShowDisputeForm(true);
  };

  return (
    <ContentContainer className='!px-2 m-0 bg-gray-100'>
      <div className='flex flex-col gap-3'>
        <h1 className='text-2xl text-black font-bold mb-5'>{t('jobInvitations')}</h1>
        <div className="flex flex-col gap-4">
           {fetchingJobs && (
            <div className="flex flex-col gap-4">
              {[...Array(5)].map((_, i) => (
                <JobSkeleton key={i} />
              ))}
            </div>
          )}

            {jobs?.data?.map((job, i) => {
              const statusConfig = getStatusConfig(job.status);
              const paymentSummary = getPaymentSummary(job?.job);
              const isOnMyWay = job.status === 'on_my_way';
              const distanceToJob = distancesByJobId[job._id];
              return (
                <div key={job?.job?._id} className="bg-white border border-gray-200 rounded-xl px-6 py-6 shadow-sm cursor-pointer" onClick={() => { setSelectedJob(job); setShowPopup(true); }}>
                  <div className="grid lg:grid-cols-7 md:grid-cols-3 grid-cols-2 gap-4 items-start">
                    <div className="flex flex-col gap-2">
                      <span className="text-sm font-semibold text-black">{t('clientName')}</span>
                      <span className="truncate max-w-[120px]" title={job?.job?.user?.fullName || 'N/A'}>
                        {job?.job?.user?.fullName || 'N/A'}
                      </span>
                    </div>
                    <div className="flex flex-col gap-2">
                      <span className="text-sm font-semibold text-black">
                        {job?.job?.paymentType === 'fixed' ? t('fixed') : t('hourly')}
                      </span>
                      <span>
                        {job?.job?.paymentType === 'fixed'
                          ? `$${job?.job?.budget}`
                          : `$${job?.job?.hourlyRate}`}
                      </span>
                    </div>
                    <div className="flex flex-col gap-2">
                      <span className="text-sm font-semibold text-black">{t('totalHours')}</span>
                      <span>
                        {job?.job?.paymentType === 'fixed'
                          ? '-'
                          : job?.job?.totalHours}
                      </span>
                    </div>
                    <div className="flex flex-col gap-2">
                      <span className="text-sm font-semibold text-black">{t('date')}</span>
                      <span>{moment(job?.createdAt).format('DD MMM YYYY')}</span>
                    </div>
                    <div className="flex flex-col gap-2">
                      <span className="text-sm font-semibold text-black">{t('chats')}</span>
                      <span>
                        <IconButton size='small' onClick={(e) => {
                          e.stopPropagation();
                          handleChatNavigation(job);
                        }}>
                          <ChatBlackIcon />
                        </IconButton>
                      </span>
                    </div>
                    <div className="flex flex-col gap-2">
                      <span className="text-sm font-semibold text-black">{t('status')}</span>
                      <span className="flex flex-col gap-1">
                        <span className={`flex items-center gap-1 font-semibold ${statusConfig.color}`}>
                          <span className={`w-2 h-2 min-w-[8px] min-h-[8px] rounded-full ${statusConfig.dot}`}></span>
                          {statusConfig.text}
                        </span>
                        {paymentSummary.workerPaymentMethod && (
                          <span className="text-xs text-gray-500">
                            {formatPaymentMethod(paymentSummary.workerPaymentMethod, t)}
                          </span>
                        )}
                        {isOnMyWay && distanceToJob != null && (
                          <span className="text-xs text-teal-600">
                            {t('distanceToJob', { distance: formatDistanceMeters(distanceToJob) })}
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      className="col-span-2 md:col-span-3 lg:col-span-1 flex justify-start lg:justify-end gap-2 flex-wrap items-center"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      {statusConfig.showButtons && statusConfig.buttons.map((button, index) => (
                        <CustomButton
                          key={index}
                          label={button.label}
                          className={`px-4 py-2 !rounded-3xl font-semibold ${button.className} cursor-pointer ${button.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                          labelStyle={button.labelStyle}
                          handleButtonClick={button.disabled ? undefined : () => showVerification(job._id, button.action, button.label, job.worker.workerProfile.isStripeOnBoardingCompleted)}
                          disabled={button.disabled}
                        />
                      ))}
                      {canCreateDispute(job) && (
                        <CustomButton
                          label={t('createDispute')}
                          type='button'
                          className="px-4 py-2 !rounded-3xl bg-red-500 text-white border font-semibold cursor-pointer"
                          labelStyle="text-white"
                          handleButtonClick={(e) => {
                            if (e) e.stopPropagation();
                            openDisputeForm(job);
                          }}
                          disabled={isSubmittingDispute}
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
             {!fetchingJobs && jobs?.data?.length === 0 && (
            <div className="flex justify-center items-center h-full">
              <span className="text-gray-500 text-sm">{t('noDataFound')}</span>
            </div>
          )}
        </div>
        <div className="flex justify-center">

          
<Pagination
  count={jobs?.totalPages || 1}
  color="primary"
  variant="outlined"
  page={offset}
  onChange={handleChangePage}
  showFirstButton
  showLastButton
  siblingCount={0}
/>
</div>
     
      </div>
      {/* Popup for job invitation details */}
   <Popup
  isOpen={showPopup}
  handleClose={() => setShowPopup(false)}
  className="bg-white"
  size="md"
  headerTitle={t('viewInvitation')}
  isShowCloseIcon
  isShowBlackCrossIcon
  isShowDivider
  bodyChildren={
    selectedJob && (
      <div className="p-4 w-full overflow-y-auto max-h-[80vh]">
        {/* Prevent horizontal overflow */}
        <div className="w-full overflow-x-hidden break-words">

          {/* Details grid */}
          <div className="grid lg:grid-cols-5 md:grid-cols-4 grid-cols-2 w-full gap-2 gap-y-4 text-sm font-semibold border-b border-gray-200 pb-2 mb-4">
            <div>
              <div className="text-sm text-black font-semibold mb-1">{t('jobId')}</div>
              <div
                className=" max-w-[120px] font-normal text-black"
                title={selectedJob?.job?.uid || 'N/A'}
              >
                {selectedJob?.job?.uid || 'N/A'}
              </div>
            </div>

            <div>
              <div className="text-sm text-black font-semibold mb-1">{t('clientName')}</div>
              <div
                className="truncate max-w-[120px] font-normal text-black"
                title={selectedJob?.job?.user?.fullName || 'N/A'}
              >
                {selectedJob?.job?.user?.fullName || 'N/A'}
              </div>
            </div>

            <div className="col-span-full">
              <JobPaymentSummarySection
                summary={getPaymentSummary(selectedJob?.job)}
                variant="worker"
              />
            </div>

            <JobCommissionBreakdown job={selectedJob?.job} variant="worker" />

            <div>
              <div className="text-sm text-black font-semibold mb-1">{t('service_name')}</div>
              <div
                className="truncate max-w-[140px] font-normal text-black"
                title={getServiceName(selectedJob?.job)}
              >
                {getServiceName(selectedJob?.job)}
              </div>
            </div>

            <div>
              <div className="text-sm text-black font-semibold mb-1">{t('date')}</div>
              <div className="font-normal text-black">
                {moment(selectedJob?.createdAt).format('DD MMM YYYY')}
              </div>
            </div>

            <div>
              <div className="text-sm text-black font-semibold mb-1">{t('status')}</div>
              <div className={`font-semibold ${getStatusConfig(selectedJob?.status).color}`}>
                {getStatusConfig(selectedJob?.status).text}
              </div>
            </div>
          </div>

          <Divider className="border-gray-400 my-4" />

          {/* Description */}
          <div className="mb-4">
            <div className="font-semibold mb-1">{t('description')}:</div>
            <div className="text-gray-700 text-sm mb-5 whitespace-pre-wrap break-words">
              {selectedJob?.job?.description}
            </div>
          </div>

          <Divider className="border-gray-400 my-4" />

          {/* Attachments */}
          <div className="mb-4">
            <div className="font-semibold mb-1">{t('attachment')}:</div>
            <div className="flex flex-wrap gap-3">
              {selectedJob?.job?.imageUrls && selectedJob?.job?.imageUrls?.length > 0 ? (
                selectedJob?.job?.imageUrls.map((url: string, idx: number) => (
                  <img
                    key={idx}
                    src={url}
                    alt={`attachment-${idx}`}
                    className="h-24 w-24 object-cover rounded-lg border border-gray-200 cursor-pointer hover:scale-105 hover:shadow-md transition-all duration-200"
                    onClick={() => setPreviewImage(url)}
                  />
                ))
              ) : (
                <span className="text-gray-400 text-xs">{t('noAttachments')}</span>
              )}
            </div>
          </div>

           {/* Check-In Location */}
           {(selectedJob?.status === 'on_my_way') && (
             <div className="mb-2">
               <div className="font-semibold mb-1">{t('arrivalLocation')}:</div>
               <div className="font-semibold mb-1">{t('liveLocation')}:</div>
               <LiveLocation
                 userId={selectedJob?.job?.user?._id}
                 jobLocation={selectedJob?.job?.location}
                 jobId={selectedJob?.job?._id}
                 distanceMeters={distancesByJobId[selectedJob?._id]}
                 autoArrivalEnabled={gpsAvailable && hasActiveTracking}
                 workerPosition={hasActiveTracking ? workerPosition : undefined}
                 pageLevelBroadcast={hasActiveTracking}
               />
             </div>
           )}

           {/* Active Dispute Badge */}
           {activeDisputes[selectedJob?.job?._id] && (
             <>
               <Divider className="border-gray-400 my-4" />
               <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                 <div className="font-semibold text-yellow-800 mb-1">{t('dispute')}</div>
                 <div className="text-sm text-yellow-700">
                   {t('activeDisputeExists')} {t('disputeStatus')}: {t(activeDisputes[selectedJob.job._id].status.toLowerCase().replace('_', ''))}
                 </div>
               </div>
             </>
           )}
         </div>
       </div>
     )
   }
 />

        {previewImage && (
          <Popup
            isOpen={!!previewImage}
            handleClose={() => setPreviewImage(null)}
            size="lg"
            className="bg-black bg-opacity-80 flex items-center justify-center"
            isShowCloseIcon
            isShowBlackCrossIcon
            bodyChildren={
              <div className="flex justify-center items-center w-full h-full">
                <img
                  src={previewImage}
                  alt="Preview"
                  className="max-h-[90vh] max-w-full object-contain rounded-lg shadow-lg"
                />
              </div>
            }
          />
        )}

   <Popup
      isOpen={showStripePopup}
      handleClose={() => setShowStripePopup(false)}
      className="bg-white"
      size="sm"
      headerTitle={t(`StripeOnboardingInComplete`)}
      isShowCloseIcon={false}
      isShowDivider
      bodyChildren={
        <div className="p-4 text-center">
          <p className="text-gray-700 text-base mb-6">
            {t(`YoourStripeOnboardingInComplete`)} <br />
            {t(`CompleteOnboarding`)}
          </p>

          <div className="flex justify-center gap-3">
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setShowStripePopup(false)}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                px: 4,
                py: 1,
              }}
              disabled={loadingStripeLink}
            >
              {t(`close`)}
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={handleStripeOnboarding}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                px: 4,
                py: 1,
              }}
              disabled={loadingStripeLink}
            >
              {loadingStripeLink ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                t(`GoToStripeOnboarding`)
              )}
            </Button>
          </div>
        </div>
      }
    />

      {/* VerifySubmission Popup */}
      <VerifySubmission
        isOpen={showVerificationPopup}
        handleClose={cancelStatusChange}
        handleSubmit={confirmStatusChange}
        isLoading={isLoading}
        size="xs"
      >
        {pendingAction && (
          <div className="text-center">
            <div className="text-lg font-semibold text-gray-800 mb-2">
              {t('confirmAccept', { action: pendingAction?.label?.toLowerCase() })}
            </div>
            <div className="text-sm text-gray-600">
              {t('irreversible_action')}
            </div>
          </div>
        )}
      </VerifySubmission>

      {/* Dispute Form Popup */}
      <Popup
        isOpen={showDisputeForm}
        handleClose={() => {
          setShowDisputeForm(false);
          resetDisputeForm();
        }}
        className="bg-white"
        size="md"
        headerTitle={t('createDispute')}
        isShowCloseIcon
        isShowBlackCrossIcon
        isShowDivider
        bodyChildren={
          <div className="p-4 w-full">
            <div className="flex flex-col gap-4">
              {/* Issue Type */}
              <FormControl fullWidth required>
                <InputLabel>{t('issueType')}</InputLabel>
                <Select
                  value={disputeIssueType}
                  onChange={(e) => setDisputeIssueType(e.target.value)}
                  label={t('issueType')}
                >
                  {selectedJob?.status === 'successfully_completed' ? (
                    <MenuItem value="delayed_payout">{t('delayedPayout')}</MenuItem>
                  ) : (
                    <>
                      <MenuItem value="payment_issue">{t('paymentIssue')}</MenuItem>
                      <MenuItem value="work_quality">{t('workQuality')}</MenuItem>
                      <MenuItem value="behavior">{t('behavior')}</MenuItem>
                      <MenuItem value="delayed_payout">{t('delayedPayout')}</MenuItem>
                      <MenuItem value="other">{t('other')}</MenuItem>
                    </>
                  )}
                </Select>
              </FormControl>

              {/* Description */}
              <div>
                <label className="block text-sm font-semibold mb-2 text-black">
                  {t('disputeDescription')} <span className="text-red-500">*</span>
                </label>
                <TextArea
                  name="disputeDescription"
                  value={disputeDescription}
                  onChange={(e) => setDisputeDescription(e.target.value)}
                  placeholder={t('disputeDescriptionPlaceholder')}
                  className="w-full min-h-[120px] rounded text-base"
                  maxLength={2000}
                />
                <div className="flex justify-between items-center mt-2">
                  <span className="text-xs text-gray-400">
                    {disputeDescription.length}/2000 {t('characters')}
                  </span>
                  {disputeDescription.length > 0 && disputeDescription.length < 20 && (
                    <span className="text-xs text-red-500">
                      Mínimo 20 caracteres
                    </span>
                  )}
                </div>
              </div>

              {/* Image Upload */}
              <div>
                <label className="block text-sm font-semibold mb-2 text-black">
                  {t('uploadImages')} ({t('maxImages')})
                </label>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => {
                    if (e.target.files) {
                      handleDisputeImageChange(Array.from(e.target.files));
                    }
                    e.target.value = '';
                  }}
                  className="hidden"
                  id="dispute-image-upload-worker"
                />
                <label
                  htmlFor="dispute-image-upload-worker"
                  className="block w-full p-4 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-blue-500 transition-colors text-center"
                >
                  <span className="text-gray-600">{t('uploadImages')}</span>
                </label>

                {/* Image Previews */}
                {disputeImagePreviews.length > 0 && (
                  <div className="flex flex-wrap gap-3 mt-4">
                    {disputeImagePreviews.map((preview, idx) => (
                      <div key={idx} className="relative">
                        <img
                          src={preview}
                          alt={`Preview ${idx + 1}`}
                          className="h-20 w-20 object-cover rounded-md border"
                        />
                        <button
                          type="button"
                          onClick={() => handleRemoveDisputeImage(idx)}
                          className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Action Buttons */}
              <div className="flex gap-4 justify-end mt-4">
                <CustomButton
                  label={t('cancel')}
                  className="!rounded-lg px-6 py-3 border bg-white border-gray-300"
                  labelStyle="text-base text-gray-700"
                  handleButtonClick={() => {
                    setShowDisputeForm(false);
                    resetDisputeForm();
                  }}
                />
                <CustomButton
                  label={t('submitDispute')}
                  className="!rounded-lg px-6 py-3 bg-red-500"
                  labelStyle="text-base text-white"
                  handleButtonClick={handleSubmitDispute}
                  disabled={isSubmittingDispute || !disputeIssueType || disputeDescription.trim().length < 20}
                  isLoading={isSubmittingDispute}
                />
              </div>
            </div>
          </div>
        }
      />
    </ContentContainer>
  );
};

export default MyJobs;
